export const EMAIL_ADDRESS_NOT_FOUND = 'EMAIL_ADDRESS_NOT_FOUND';
export const USER_NOT_FOUND = 'LabCentral User';

export const REGULATOR_CENTRAL_SITE = 'RegulatorCentral';
export const REGULATOR_CENTRAL_CLIENT_ID = 'RegulatorCentral';

export const MAX_RETRY_ATTEMPT = 3;
export const DATA_STORED_IN_API_CACHE_SECS = 60;
export const FETCH_RETRY_DELAY_MS = 500; //retry delay in ms
export const DMS_API_PREFIX = `/ShipDocsDMS`;
export const RCMS_SERVICE_PREFIX = `/rcms`;
export const UMS_SERVICE_PREFIX = '/ums';
export const DDM_SERVICE_PREFIX = '/ddm-api';
export const DDM_CPR_CLIENT_ID = 'CPR';
export const UMS_ACCOUNT_ENTITY_CLASS = 'LENS-UMS-Account';

export const UPLOAD_MAX_FILE_SIZE = 18874368; //size in bytes for 18mb
export const SPIM_MAX_TOTAL_ATTACHMENTS_SIZE = 40000000; // 38.15 MB in bytes
export const SPIM_MAX_NUMBER_OF_ATTACHMENTS = 100;

export const MIN_CASES_TO_FETCH = 100; //By default this is the min number of cases to be fetched to unblock CPR users
export const MAX_CASES_IN_EACH_BATCH = 500; //This constant is added to specify the max cases to be added in batch.
export const MAX_DEFAULT_RETRY = 3; //max default retry

export enum Method {
  POST = 'POST',
  PUT = 'PUT',
  GET = 'GET',
}

export const MANDATORY_FIELD_INFORMATION =
  'message_fields_marked_with_star_are_mandatory';

export type IAgencyDetails = {
  agencyName: string;
  accountId: string;
  emailDomain: string;
};

export const AMAZON_AGENCY_DETAILS = {
  agencyName: 'Amazon',
  accountId: 'AMAZON',
};
export enum APP_CONTAINER_BASE_URL {
  PAYMENTS_SERVICES_COMPLAINT = 'PAYMENTS_SERVICES_COMPLAINT', //points to /payments-services-complaint
  REPORT_CSAM = 'REPORT_CSAM', //points to /report-csam
  HRECOMPLAINTS = 'HRECOMPLAINTS', //points to /hrecomplaints
  REGULATOR_CENTRAL = 'REGULATOR_CENTRAL', //point to /regulatorCentral
  ARTICLE_11_DSA = 'ARTICLE_11_DSA', //point to article-11-dsa
  SPIM = 'mpa-escalations', //points to /mpa-escalations
}

export enum UI_CLIENTS {
  VICI = 'VICI',
  RegulatorCentral = 'RegulatorCentral',
}

export enum PAGE_SCOPE {
  PUBLIC = 'PUBLIC',
  AUTHENTICATED = 'AUTHENTICATED',
}

export enum PAGE_NAME {
  LIST_CASE = 'LIST_CASE',
  CREATE_CASE = 'CREATE_CASE',
  ADMIN = 'ADMIN',
  ANONYMOUS_CREATE_CASE = 'ANONYMOUS_CREATE_CASE',
  CASE_SUMMARY = 'CASE_SUMMARY',
}

export const GENERIC_AGENCY_NAME = 'Authority';
export const AMAZON_USERID_REGEXP = new RegExp('A[0-9A-Z]{6,20}');

export enum KatDataGridFilters {
  AG_DATE_COLUMN_FILTER = 'agDateColumnFilter',
}

export enum CONFIG_TYPE {
  LOCALIZATION = 'LOCALIZATION',
  BRANDING = 'BRANDING',
  FEATURE_FLAGS = 'FEATURE_FLAGS',
  MENU = 'MENU',
  CASE_LIST = 'CASE_LIST',
  PROPERTIES = 'PROPERTIES',
}

export enum CASE_LIST_COLUMN {
  CASE_ID = 'caseId',
  PARAGON_CASE_IDS = 'paragonCaseIds',
  CASE_TITLE = 'caseTitle',
  CREATED_ON = 'createdOn',
  CREATED_BY_USER = 'createdByUser',
  LAST_UPDATED_ON = 'lastUpdatedOn',
  LAST_UPDATED_BY_USER = 'lastUpdatedByUser',
  CASE_STATUS = 'caseStatus',
  ASSIGNEE = 'assignee',
  CASE_LOCALE = 'caseLocale',
}

/**
 * This enum defines schema id's, which are common across accounts of a program.
 */
export enum DDM_SCHEMA_ID_FOR_PROGRAMS {
  PRODUCT_SAFETY_REGULATORY_INTAKE_EU = 'PRODUCT-SAFETY-REGULATORY-INTAKE-EU',
  GTS_BROKER_INTAKE = 'GTS-BROKER-INTAKE',
  SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS = 'SOCIAL-RESPONSIBILITY-AUDIT-REQUESTS',
  DSA_OUT_OF_COURT_SETTLEMENT = 'DSA-OUT-OF-COURT-SETTLEMENT',
  FOOD_SAFETY_NA = 'FOOD-SAFETY-NA',
  SUSTAINABILITY = 'SUSTAINABILITY', // social responsibility hre complaints
  CSAM = 'CSAM',
  PAYMENTS_SERVICES_COMPLAINT = 'PAYMENT-SERVICES-COMPLAINT',
  EPR_EU_INTERNAL = 'EPR-EU-INTERNAL',
  TRUSTED_CONSUMER = 'TRUSTED-CONSUMER',
  RISC_CPSC_NA = 'RISC-CPSC-NA',
  SPIM = 'SPIM',
  DSA_POC = 'DSA-POC',
}

//All UMS accounts quip: https://quip-amazon.com/p6QRAB9RbsKQ/UMS-Account-List
export enum PROGRAM_ACCOUNTS {
  // GTS Accounts
  CEVA_LOGISTICS_UK = 'A8T6BY4K34QGCD',
  CEVA_LOGISTICS_IE = 'A35X16HUEV8MLV',
  CHARLES_KENDALL = 'A13OZRYF9POW3S',
  KERRY_LOGISTICS = 'AZLFOVJCR65TXG',
  AN_POST_IE = 'ARUPIZUULKT68F',
  CUSTOMS_BROKER_DE = 'A5LXHKTZC25C8O',
  GTS_DHL = 'A2WBSE4EV7U6BI',
  GTS_DB_SCHENKER = 'A3NWSZA3I56318',
  GTS_TIMBRO_TRADING = 'A1UW561U8IYXYA',
  GTS_ECT = 'A22FNOO0JUXV1Y',

  // Social Responsibility Auditor Accounts
  SOCIAL_RESPONSIBILITY_AUDITOR_BAUREAU_VERITAS = 'A9O4YOFHHX84Y',
  SOCIAL_RESPONSIBILITY_AUDITOR_ELEVATE = 'A3GCF4MRJ7E7Q1',
  SOCIAL_RESPONSIBILITY_AUDITOR_SGS = 'A39VOX6V4SHVZ0',
  SOCIAL_RESPONSIBILITY_AUDITOR_INTERTEK = 'A25WWSZCZLQKKS',
  SOCIAL_RESPONSIBILITY_AUDITOR_EUROFINS = 'A16DNHT4J03G5V',
  SOCIAL_RESPONSIBILITY_AUDITOR_ARCH = 'A34VEQBA2062ZY',
  SOCIAL_RESPONSIBILITY_AUDITOR_QIMA = 'ATYEAAM9VCWXU',

  // Artifact Central/MINT Accounts. Prefix all Account names with AC_
  AC_TEST_3PL = 'A3IXJ9TV9Z6BZF',
  AC_XESF_ES_CEVA_LOGISTICS = 'APXH2PU6Z1VQU',
  AC_XFRZ_FR_CEVA_LOGISTICS = 'A23P7ADGMHLFMY',
  AC_XITI_IT_GEODIS = 'A34FPN6Y2D135L',
  AC_XLP1_UK_GREATBEAR = 'A2X5HCOJHNSN8H',
  AC_XDR1_PL_ID_LOGISTICS = 'A1MTR2WDZUD2FX',
  AC_XFR4_DE_ID_LOGISTICS = 'A22XU0Y2MKX24C',
  AC_XTRA_TR_CEVA_LOGISTICS = 'AAGXKVMKPOQYB',
  AC_XAR1_SE_KUEHNENAGEL = 'A1601CZLXOHEKA',
  AC_PNLD_NL_BLECKMANN = 'A1EAIIZI85FALZ',
  AC_3PL_SME_HAZMAT = 'A1X792993BFSJO',
  AC_VOSTOK = 'A14LMRYOO7YUDE',
  AC_PRODUCT_AND_FOOD_SAFETY = 'AIMBE4EZ1AKHF',

  // DSA OOCS Accounts. Prefix all Account names with DSA_OOCS_
  DSA_OOCS_ADRIOT_OOC_SETTLEMENT = 'A2VX5D8J1F424P',
  DSA_OOCS_RUNDFUNK_UND_TELEKOM_REGULIERUNGS_GMBH = 'A1WT9EUE0H8032',
  DSA_OOCS_ADR_CENTER = 'A2IVK0GTQ8R1Q2',

  // Other Accounts
  AMAZON_TESTING = 'AZ5PEQCAY0EUL6',
  EU_DSA_TRUSTED_FLAGGER = 'A3IGKZZCOQDTS5',
  FOOD_SAFETY_NA = 'A3P5ROKL5A1OLE',
  EPR_EU_INTERNAL = 'AU6IV936A2CUL',
  SUSTAINABLITY = 'A2Y0W6CII9J4R3',
  JP_CUSTOMS = 'A36FYNOX0Z3A3B',
  TRUSTED_CONSUMER = 'A22Q31JQ4R8GUD',
  JPMA = 'A3VBSBPITPDADN',
  CSAM = 'A17X69BODPCNDK',
  DSA_POC = 'AAMK7NPOVZNJM',
  PAYMENTS_SERVICES_COMPLAINT = 'A1KAK3W7EJX5SR',

  // RISC Accounts TODO - Update to actual name after UA,
  RISC_CPSC_NA = 'A91AEGWKAON9B',

  // PSC Accounts
  PSC_HERTFORDSHIRE = 'A1P4R2V3LKJGLP',
  PSC_BNETZA = 'A2EXCHW9M1P7GN',
  PSC_REGIERUNG_VON_MITTELFRANKEN = 'A26M7LVNTEE2Y9',
  PSC_REGIERUNG_VON_OBERBAYERN = 'A1W7011GWQ5XYG',
  PSC_REGIERUNG_VON_NIEDERBAYERN = 'A3HQZJ1Y90Z7F1',
  PSC_KRAFTFAHRT_BUNDESAMT = 'AETFTPOULOTY',
  PSC_REGIERUNG_VON_OBERFRANKEN = 'A6QROCV44LP7U',
  PSC_ZLS = 'A31MGY83S7UB76',
  PSC_LBA = 'A1CIYTVSI9Z2B6',
  PSC_SACHSEN_ANHALT = 'A12QFF6I3XFTGB',
  PSC_SUFFOLK_COUNTY = 'A1KRK53KLF3EFA',
  PSC_OBERPFALZ = 'A34P857DDSK9GI',
  PSC_DUSSELDORF = 'A1JLTUPX2TY9CK',
  PSC_LANUV_NRW = 'A32HOPCPNNHCBT',
  PSC_OFCOM_UK = 'A6I738CLOTYTB',
  PSC_CCPC_IE = 'A2S7CJFE07L1LE',
  PSC_MHRA_UK = 'ATPKOFII2HLWC',
  PSC_DVSA_UK = 'A2BFTRMXPRTJK4',
  PSC_OPSS_UK = 'A3D52DQVS7JSFZ',
  PSC_VMD_UK = 'A2RBUTMGV5SP0',
  PSC_NEWHAM_COUNTY_COUNCIL = 'A2HS46NDOFX0DD',
  PSC_DEFRA_UK = 'A2LH33ZL5GKYBR',
  PSC_COMREG_IE = 'A2CHHZEZ8S9LEY',
  PSC_DDPP_FR = 'A1QXM91QQQWOMH',
  PSC_REGIERUNGSPRASIDIUM_TUBINGEN = 'AJERG74LE5NM',
  PSC_COMUNIDAD_DE_MADRID = 'A36MTQFPKQR653',
  PSC_LDS_SACHSEN_DRESDEN = 'A3C8TUM7WZKNZK',
  PSC_LDS_SACHSEN_LEIPZIG = 'A16RGCSQQB0LDJ',
  PSC_REGIERUNG_VON_UNTERFRANKEN = 'A1Y8E939AP0BCW',
  PSC_XUNTA_DE_GALICIA = 'A2O3UQ952E964G',
  PSC_REGIERUNGSPRASIDIUM_DARMSTADT = 'A2481J8O8Z2FU2',
  PSC_BEV_METROLOGY_SERVICE = 'AYUUS3O7SYPY8',
  PSC_ILNAS_LU = 'A1G9AA2JYQE22K',
  PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_BRAUNSCHWEIG = 'A1O6BSNV92C2GL',
  PSC_REGIERUNG_VON_SCHWABEN = 'A1CI7A81O3O0F0',
  PSC_CONSEJERIA_DE_DESARROLLO_SOSTENIBLE_CASTILLA_LA_MANCHA = 'A2Q12OC0W384YN',
  PSC_HESSISCHE_EICHDIREKTION = 'A392LV09DTM03Y',
  PSC_BEHORDE_FUR_JUSTIZ_UND_VERBRAUCHERSCHUTZ_HAMBURG = 'A3HFPK0F72GDX3',
  PSC_T_C_SANAYI_VE_TEKNOLOJI_BAKANLIGI = 'A1YBEDXWCLMXCF',
  PSC_AEMPS_ES = 'A206X87C0J06XT',
  PSC_MINISTERIO_DE_ASUNTOS_ECONOMICOS_Y_TRANSFORMACION_DIGITAL = 'A2F5K4M36XVK3V',
  PSC_BEZIRKSREGIERUNG_MUNSTER = 'A3CT054HX1186R',
  PSC_LAKEMEDICINALVERKET = 'A2UXNZXAL9ICEH',
  PSC_LANDESHAUPTSTADT_MUNCHEN = 'A25AVZN69S4B5V',
  PSC_KEMIKALIEINSPEKTIONEN = 'A3NYHCMPMDT5ME',
  PSC_LANDESAMT_BRANDENBURG = 'AP7HJV1TNPHEM',
  PSC_DIRECTION_GENERALE_DE_LA_PREVENTION_DES_RISQUES = 'AZ13ZQ7VQMX99',
  PSC_GUARDIA_DI_FINANZA = 'A2UGZOIT21UJME',
  PSC_REGIONE_LIGURIA_NUCLEO_VIGILANZA_FAUNISTICO_AMBIENTALE = 'A2QABL24L1NGO9',
  PSC_INSTITUTO_GALEGO_DE_CONSUMO = 'AY7JBTVETRLKW',
  PSC_BEZIRKSREGIERUNG_ARNSBERG = 'A1RYZTRORRNFC9',
  PSC_BAYERISCHES_LANDESAMT_FUR_GESUNDHEIT_UND_LEBENSMITTELSICHERHEIT = 'AXCH9WDGJMBPU',
  PSC_BEZIRKSREGIERUNG_KOLN = 'AB0D38HKU7HFG',
  PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_HILDESHEIM = 'A3BMDDFT6GJTXX',
  PSC_DDPP_PARIS = 'A22NW1IM5CT6FY',
  PSC_ANFR = 'A1QQ5CIIW6SNK8',
  PSC_LANDKREIS_HOF = 'A3KLDTWGZ778TR',
  PSC_LE_GOUVERNEMENT_DU_GRAND_DUCHE_DE_LUXEMBOURG = 'A383JAB914EA1Q',
  PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_HANNOVER = 'A32RY1B4VTJ87I',
  PSC_NIEDERSACHSEN_GEWERBEAUFSICHT = 'A12SOQ01Z2WW0I',
  PSC_REGIERUNGSPRAESIDIUM_GIESSEN = 'A30WNUBWOT0AB8',
  PSC_VETERINAR_UND_LEBENSMITTELWESEN_KREIS_WESEL = 'AIUR5S46T74XV',
  PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_SUD_RHEINLAND_PFALZ = 'A25B1BNBVXF55',
  PSC_LAGESO_BERLIN = 'A1X5CV4SW6JRNM',
  PSC_BUNDESAMT_FUR_VERBRAUCHERSCHUTZ_UND_LEBENSMITTELSICHERHEIT_ZOPF = 'A275A7ND3NU5T8',
  PSC_LANDSAMT_FUR_UMWELT_UND_ARBEITSSCHUTZ_SAARLAND_FACHBEREICH_4 = 'A58XLOYLO33JT',
  PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_NORD_GEWERBEAUFSICHT_KOBLENZ = 'AWRW33B33QDFA',
  PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_NORD_GEWERBEAUFSICHT_TRIER = 'A3PSZ9HXLLCNZO',
  PSC_BELGIAN_FEDERAL_PUBLIC_SERVICE_OF_HEALTH = 'A2IO49R2T6HBCQ',
  PSC_HPRA_IE = 'A31GR8I2Z6AIQ1',
  PSC_DUTCH_HEALTH_AND_YOUTHCARE_INSPECTOR = 'ARJTOV6CVUNKV',

  // Paragon Accounts
  SPIM = 'A3E3KFOOMNEJQX',
}

export const AccountId = {
  GTS: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.GTS_BROKER_INTAKE.valueOf(), //Parent schema
    PROGRAM_ACCOUNTS.CEVA_LOGISTICS_UK.valueOf(),
    PROGRAM_ACCOUNTS.CEVA_LOGISTICS_IE.valueOf(),
    PROGRAM_ACCOUNTS.CHARLES_KENDALL.valueOf(),
    PROGRAM_ACCOUNTS.KERRY_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AN_POST_IE.valueOf(),
    PROGRAM_ACCOUNTS.CUSTOMS_BROKER_DE.valueOf(),
    PROGRAM_ACCOUNTS.GTS_DB_SCHENKER.valueOf(),
    PROGRAM_ACCOUNTS.GTS_DHL.valueOf(),
    PROGRAM_ACCOUNTS.GTS_TIMBRO_TRADING.valueOf(),
    PROGRAM_ACCOUNTS.GTS_ECT.valueOf(),
  ],
  PRODUCT_SAFETY: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.PRODUCT_SAFETY_REGULATORY_INTAKE_EU.valueOf(), //Parent schema
    PROGRAM_ACCOUNTS.AMAZON_TESTING.valueOf(),
    PROGRAM_ACCOUNTS.PSC_HERTFORDSHIRE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BNETZA.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_MITTELFRANKEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_OBERBAYERN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_NIEDERBAYERN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_OBERFRANKEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_KRAFTFAHRT_BUNDESAMT.valueOf(),
    PROGRAM_ACCOUNTS.PSC_ZLS.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LBA.valueOf(),
    PROGRAM_ACCOUNTS.PSC_SACHSEN_ANHALT.valueOf(),
    PROGRAM_ACCOUNTS.PSC_SUFFOLK_COUNTY.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DUSSELDORF.valueOf(),
    PROGRAM_ACCOUNTS.PSC_OBERPFALZ.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LANUV_NRW.valueOf(),
    PROGRAM_ACCOUNTS.PSC_OFCOM_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_CCPC_IE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_MHRA_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DVSA_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_OPSS_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_VMD_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_NEWHAM_COUNTY_COUNCIL.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DEFRA_UK.valueOf(),
    PROGRAM_ACCOUNTS.PSC_COMREG_IE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DDPP_FR.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNGSPRASIDIUM_TUBINGEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_COMUNIDAD_DE_MADRID.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LDS_SACHSEN_DRESDEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LDS_SACHSEN_LEIPZIG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_UNTERFRANKEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_XUNTA_DE_GALICIA.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNGSPRASIDIUM_DARMSTADT.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BEV_METROLOGY_SERVICE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_ILNAS_LU.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_BRAUNSCHWEIG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNG_VON_SCHWABEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_CONSEJERIA_DE_DESARROLLO_SOSTENIBLE_CASTILLA_LA_MANCHA.valueOf(),
    PROGRAM_ACCOUNTS.PSC_HESSISCHE_EICHDIREKTION.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BEHORDE_FUR_JUSTIZ_UND_VERBRAUCHERSCHUTZ_HAMBURG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_T_C_SANAYI_VE_TEKNOLOJI_BAKANLIGI.valueOf(),
    PROGRAM_ACCOUNTS.PSC_AEMPS_ES.valueOf(),
    PROGRAM_ACCOUNTS.PSC_MINISTERIO_DE_ASUNTOS_ECONOMICOS_Y_TRANSFORMACION_DIGITAL.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BEZIRKSREGIERUNG_MUNSTER.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LAKEMEDICINALVERKET.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LANDESHAUPTSTADT_MUNCHEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_KEMIKALIEINSPEKTIONEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LANDESAMT_BRANDENBURG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DIRECTION_GENERALE_DE_LA_PREVENTION_DES_RISQUES.valueOf(),
    PROGRAM_ACCOUNTS.PSC_GUARDIA_DI_FINANZA.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIONE_LIGURIA_NUCLEO_VIGILANZA_FAUNISTICO_AMBIENTALE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_INSTITUTO_GALEGO_DE_CONSUMO.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BEZIRKSREGIERUNG_ARNSBERG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BAYERISCHES_LANDESAMT_FUR_GESUNDHEIT_UND_LEBENSMITTELSICHERHEIT.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BEZIRKSREGIERUNG_KOLN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_HILDESHEIM.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DDPP_PARIS.valueOf(),
    PROGRAM_ACCOUNTS.PSC_ANFR.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LANDKREIS_HOF.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LE_GOUVERNEMENT_DU_GRAND_DUCHE_DE_LUXEMBOURG.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STAATLICHES_GEWERBEAUFSICHTSAMT_HANNOVER.valueOf(),
    PROGRAM_ACCOUNTS.PSC_NIEDERSACHSEN_GEWERBEAUFSICHT.valueOf(),
    PROGRAM_ACCOUNTS.PSC_REGIERUNGSPRAESIDIUM_GIESSEN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_VETERINAR_UND_LEBENSMITTELWESEN_KREIS_WESEL.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_SUD_RHEINLAND_PFALZ.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LAGESO_BERLIN.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BUNDESAMT_FUR_VERBRAUCHERSCHUTZ_UND_LEBENSMITTELSICHERHEIT_ZOPF.valueOf(),
    PROGRAM_ACCOUNTS.PSC_LANDSAMT_FUR_UMWELT_UND_ARBEITSSCHUTZ_SAARLAND_FACHBEREICH_4.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_NORD_GEWERBEAUFSICHT_KOBLENZ.valueOf(),
    PROGRAM_ACCOUNTS.PSC_STRUKTUR_UND_GENEHMIGUNGSDIREKTION_NORD_GEWERBEAUFSICHT_TRIER.valueOf(),
    PROGRAM_ACCOUNTS.PSC_BELGIAN_FEDERAL_PUBLIC_SERVICE_OF_HEALTH.valueOf(),
    PROGRAM_ACCOUNTS.PSC_HPRA_IE.valueOf(),
    PROGRAM_ACCOUNTS.PSC_DUTCH_HEALTH_AND_YOUTHCARE_INSPECTOR.valueOf(),
  ],
  SUSTAINABILITY: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.SUSTAINABILITY.valueOf(),
    PROGRAM_ACCOUNTS.SUSTAINABLITY.valueOf(),
  ],
  DSA_OUT_OF_COURT_SETTLEMENT: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.DSA_OUT_OF_COURT_SETTLEMENT.valueOf(),
    PROGRAM_ACCOUNTS.DSA_OOCS_ADRIOT_OOC_SETTLEMENT.valueOf(),
    PROGRAM_ACCOUNTS.DSA_OOCS_RUNDFUNK_UND_TELEKOM_REGULIERUNGS_GMBH.valueOf(),
    PROGRAM_ACCOUNTS.DSA_OOCS_ADR_CENTER.valueOf(),
  ],
  CSAM: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.CSAM.valueOf(),
    PROGRAM_ACCOUNTS.CSAM.valueOf(),
  ],
  PAYMENTS_SERVICES_COMPLAINT: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.PAYMENTS_SERVICES_COMPLAINT.valueOf(),
    PROGRAM_ACCOUNTS.PAYMENTS_SERVICES_COMPLAINT.valueOf(),
  ],
  SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_BAUREAU_VERITAS.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_ELEVATE.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_SGS.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_INTERTEK.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_EUROFINS.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_ARCH.valueOf(),
    PROGRAM_ACCOUNTS.SOCIAL_RESPONSIBILITY_AUDITOR_QIMA.valueOf(),
  ],
  ARTIFACT_CENTRAL: [
    PROGRAM_ACCOUNTS.AC_TEST_3PL.valueOf(),
    PROGRAM_ACCOUNTS.AC_XESF_ES_CEVA_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XFRZ_FR_CEVA_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XITI_IT_GEODIS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XLP1_UK_GREATBEAR.valueOf(),
    PROGRAM_ACCOUNTS.AC_XDR1_PL_ID_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XFR4_DE_ID_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XTRA_TR_CEVA_LOGISTICS.valueOf(),
    PROGRAM_ACCOUNTS.AC_XAR1_SE_KUEHNENAGEL.valueOf(),
    PROGRAM_ACCOUNTS.AC_PNLD_NL_BLECKMANN.valueOf(),
    PROGRAM_ACCOUNTS.AC_3PL_SME_HAZMAT.valueOf(),
    PROGRAM_ACCOUNTS.AC_VOSTOK.valueOf(),
    PROGRAM_ACCOUNTS.AC_PRODUCT_AND_FOOD_SAFETY.valueOf(),
  ],
  FOOD_SAFETY_NA: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.FOOD_SAFETY_NA.valueOf(),
    PROGRAM_ACCOUNTS.FOOD_SAFETY_NA.valueOf(),
  ],
  DSA_POC: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.DSA_POC.valueOf(),
    PROGRAM_ACCOUNTS.DSA_POC.valueOf(),
  ],
  EPR_EU_INTERNAL: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.EPR_EU_INTERNAL.valueOf(),
    PROGRAM_ACCOUNTS.EPR_EU_INTERNAL.valueOf(),
  ],
  TRUSTED_CONSUMER: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.TRUSTED_CONSUMER.valueOf(),
    PROGRAM_ACCOUNTS.TRUSTED_CONSUMER.valueOf(),
  ],
  RISC_CPSC_NA: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.RISC_CPSC_NA.valueOf(),
    PROGRAM_ACCOUNTS.RISC_CPSC_NA.valueOf(),
  ],
  SPIM: [
    DDM_SCHEMA_ID_FOR_PROGRAMS.SPIM.valueOf(),
    PROGRAM_ACCOUNTS.SPIM.valueOf(),
  ],
  EU_DSA_TRUSTED_FLAGGER: [PROGRAM_ACCOUNTS.EU_DSA_TRUSTED_FLAGGER.valueOf()],
  JP_CUSTOMS: [PROGRAM_ACCOUNTS.JP_CUSTOMS.valueOf()],
  JPMA: [PROGRAM_ACCOUNTS.JPMA.valueOf()],
};

export const REGULATOR_CENTRAL_CONTAINER = 'root';
export const SUSTAINABILITY_CONTAINER = PROGRAM_ACCOUNTS.SUSTAINABLITY;
export const CSAM_CONTAINER = PROGRAM_ACCOUNTS.CSAM;
export const PAYMENT_SERVICES_COMPLAINT_CONTAINER =
  PROGRAM_ACCOUNTS.PAYMENTS_SERVICES_COMPLAINT;
export const DSA_POC_CONTAINER = PROGRAM_ACCOUNTS.DSA_POC;

export const DEFAULT_PROGRAM_COUNTRY_US = 'US';

export enum BRANDING_LOGO {
  AMAZON = 'AMAZON',
}

export enum FILE_EXTENSION {
  XML = 'XML',
  CSV = 'CSV',
  DOC = 'DOC',
  DOCX = 'DOCX',
  JPEG = 'JPEG',
  JPG = 'JPG',
  PDF = 'PDF',
  PNG = 'PNG',
  TIFF = 'TIFF',
  XLSX = 'XLSX',
  XLS = 'XLS',
  TXT = 'TXT',
  ZIP = 'ZIP',
  ZIP_COMPRESSED = 'ZIP_COMPRESSED',
}

type FileFormat = {
  type: string;
  extension: string;
};

type FileFormatsMap = {
  [key in FILE_EXTENSION]: FileFormat;
};

// Ref: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const fileFormats: FileFormatsMap = {
  [FILE_EXTENSION.XML]: {
    type: 'application/xml',
    extension: 'xml',
  },
  [FILE_EXTENSION.CSV]: {
    type: 'text/csv',
    extension: 'csv',
  },
  [FILE_EXTENSION.DOC]: {
    type: 'application/msword',
    extension: 'doc',
  },
  [FILE_EXTENSION.DOCX]: {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extension: 'docx',
  },
  [FILE_EXTENSION.JPEG]: {
    type: 'image/jpeg',
    extension: 'jpeg',
  },
  [FILE_EXTENSION.JPG]: {
    type: 'image/jpeg',
    extension: 'jpg',
  },
  [FILE_EXTENSION.PDF]: {
    type: 'application/pdf',
    extension: 'pdf',
  },
  [FILE_EXTENSION.PNG]: {
    type: 'image/png',
    extension: 'png',
  },
  [FILE_EXTENSION.TIFF]: {
    type: 'image/tiff',
    extension: 'tiff',
  },
  [FILE_EXTENSION.XLSX]: {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extension: 'xlsx',
  },
  [FILE_EXTENSION.XLS]: {
    type: 'application/vnd.ms-excel',
    extension: 'xls',
  },
  [FILE_EXTENSION.TXT]: {
    type: 'text/plain',
    extension: 'txt',
  },
  [FILE_EXTENSION.ZIP]: {
    type: 'application/zip',
    extension: 'zip',
  },
  [FILE_EXTENSION.ZIP_COMPRESSED]: {
    type: 'application/x-zip-compressed',
    extension: 'zip',
  },
};

export const SOCIAL_RESPONSIBILITY_AUDIT_ACCEPTED_FILES: FILE_EXTENSION[] = [
  FILE_EXTENSION.CSV,
  FILE_EXTENSION.DOC,
  FILE_EXTENSION.DOCX,
  FILE_EXTENSION.JPEG,
  FILE_EXTENSION.JPG,
  FILE_EXTENSION.PDF,
  FILE_EXTENSION.PNG,
  FILE_EXTENSION.TIFF,
  FILE_EXTENSION.XLSX,
  FILE_EXTENSION.XLS,
  FILE_EXTENSION.TXT,
  FILE_EXTENSION.ZIP,
  FILE_EXTENSION.ZIP_COMPRESSED,
];

export const DEFAULT_ACCEPTED_FILES: FILE_EXTENSION[] = [
  FILE_EXTENSION.CSV,
  FILE_EXTENSION.DOC,
  FILE_EXTENSION.DOCX,
  FILE_EXTENSION.JPEG,
  FILE_EXTENSION.JPG,
  FILE_EXTENSION.PDF,
  FILE_EXTENSION.PNG,
  FILE_EXTENSION.TIFF,
  FILE_EXTENSION.XLSX,
  FILE_EXTENSION.XLS,
  FILE_EXTENSION.TXT,
];

export const ALLOWED_FILE_TYPES_FOR_ATTACHMENTS =
  'allowedFileTypesForAttachments';
export const MAX_TOTAL_ATTACHMENTS_SIZE = 'maxTotalAttachmentsSize';
export const MAX_NUMBER_OF_ATTACHMENTS = 'maxNumberOfAttachments';
